import { toast } from "react-toastify";
import { getErrorMessage } from "../utils/commonUtils";
import { useCreateCustomFieldsMetadataMutation,
   useDeleteCustomFieldsMetadataMutation,
   useDuplicateCustomFieldsMetadataMutation,
   useEditCustomFieldsMetadataMutation,
   useGetAllCustomFieldsValuesMutation,
   useGetCustomFieldsControlTypeMutation,
   useGetCustomFieldsDataTypeMutation,
   useGetCustomFieldsMetadataByIdMutation,
   useGetCustomFieldsMetadataMutation,
   useGetCustomFieldsModuleMutation
  } from "../redux/customFields/customFieldsApiSlice";

export default function useCustomFields() {
  const [getAllCustomFieldsValues, { isLoading: getAllCustomFieldsValuesLoading }] =
    useGetAllCustomFieldsValuesMutation();
  const [getCustomFieldsMetadata,{isLoading:getCustomFieldsMetadataLoading}] =
    useGetCustomFieldsMetadataMutation();
  const [getCustomFieldsMetadataById, {isLoading: getCustomFieldsMetadataByIdLoading}] =
    useGetCustomFieldsMetadataByIdMutation();
  const [getCustomFieldsControlType,{isLoading:getCustomFieldsControlTypeLoading}] =
    useGetCustomFieldsControlTypeMutation();
  const [getCustomFieldsDataType,{isLoading:getCustomFieldsDataTypeLoading}] =
    useGetCustomFieldsDataTypeMutation();
  const  [getCustomFieldsModule,{isLoading:getCustomFieldsModuleLoading}] =
  useGetCustomFieldsModuleMutation();
  const [createCustomFieldsMetadata, {isLoading:createCustomFieldsMetadataLoading}] =
  useCreateCustomFieldsMetadataMutation();
  const [editCustomFieldsMetadata, {isLoading: editCustomFieldsMetadataLoading}] =
    useEditCustomFieldsMetadataMutation();
  const [deleteCustomFieldsMetadata, {isLoading: deleteCustomFieldsMetadataLoading}] =
    useDeleteCustomFieldsMetadataMutation();
  const [duplicateCustomFieldsMetadata, {isLoading: duplicateCustomFieldsMetadataLoading}] =
    useDuplicateCustomFieldsMetadataMutation();

 const getCustomFieldsMetadataAPI = async ({}) => {
    try {
      const response = await getCustomFieldsMetadata({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getCustomFieldsMetadataByIdAPI = async (data: any) => {
    try {
      const response = await getCustomFieldsMetadataById(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getAlCustomFieldsValuesAPI = async ({}) => {
    try {
      const response = await getAllCustomFieldsValues({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getCustomFieldsControlTypeAPI = async ({}) => {
    try {
      const response = await getCustomFieldsControlType({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getCustomFieldsDataTypeAPI = async ({}) => {
    try {
      const response = await getCustomFieldsDataType({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getCustomFieldsModuleAPI = async ({}) => {
    try {
      const response = await getCustomFieldsModule({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const createCustomFieldsMetadataAPI = async (data: any) => {
      try {
        const response: any = await createCustomFieldsMetadata(data).unwrap();
        toast.success("Success! Custom Field has been Created.");
        return response.result;
      } catch (err: any) {
        const message = getErrorMessage(err);
        throw new Error(message);
      }
    };
  const editCustomFieldsMetadataAPI = async (data: any) => {
    try {
      const response: any = await editCustomFieldsMetadata(data).unwrap();
      toast.success("Success! Custom Field has been Updated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const deleteCustomFieldsMetadataAPI = async (data: any) => {
    try {
      const response: any = await deleteCustomFieldsMetadata(data).unwrap();
      toast.success("Success! Custom Field has been Deleted.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const duplicateCustomFieldsMetadataAPI = async (data: any) => {
    try {
      const response: any = await duplicateCustomFieldsMetadata(data).unwrap();
      toast.success("Success! Custom Field has been Duplicated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  return {
    getCustomFieldsMetadataAPI,
    getCustomFieldsMetadataLoading,
    getCustomFieldsMetadataByIdAPI,
    getCustomFieldsMetadataByIdLoading,
    getAlCustomFieldsValuesAPI,
    getAllCustomFieldsValuesLoading,
    getCustomFieldsControlTypeAPI,
    getCustomFieldsControlTypeLoading,
    getCustomFieldsDataTypeAPI,
    getCustomFieldsDataTypeLoading,
    getCustomFieldsModuleAPI,
    getCustomFieldsModuleLoading,
    createCustomFieldsMetadataAPI,
    createCustomFieldsMetadataLoading,
    editCustomFieldsMetadataAPI,
    editCustomFieldsMetadataLoading,
    deleteCustomFieldsMetadataAPI,
    deleteCustomFieldsMetadataLoading,
    duplicateCustomFieldsMetadataAPI,
    duplicateCustomFieldsMetadataLoading,
  };
}